var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMarkBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9319 15.3536L29.2929 25.7145L25.7145 29.2929L15.3536 18.9319L15 18.5784L14.6464 18.9319L4.2855 29.2929L0.707107 25.7145L11.0681 15.3536L11.4216 15L11.0681 14.6464L0.707107 4.2855L4.2855 0.707107L14.6464 11.0681L15 11.4216L15.3536 11.0681L25.7145 0.707107L29.2929 4.2855L18.9319 14.6464L18.5784 15L18.9319 15.3536Z",
    fill: "#2C3038",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkBig);
export default __webpack_public_path__ + "static/media/XMarkBig.8b6c98630ab81b5bcc2912411b33dd54.svg";
export { ForwardRef as ReactComponent };